import { FormattedMessage } from "react-intl";

import { Text } from "@ps-design-system/components/Text";

import {
  guestVatSupportLink,
  hostVatSupportLink,
} from "../../data/supportLinks";
import { TAX_DETAILS_FORM_MESSAGES } from "../TaxDetailsFormSection.messages";

import { useTaxDetailsForm } from "./TaxDetailsFormContext";

/** Heading, explainer and the support article, above the form itself. */
const TaxDetailsFormHeader = () => {
  const { isEdit, isHost, taxTypeName } = useTaxDetailsForm();

  const heading = isEdit
    ? TAX_DETAILS_FORM_MESSAGES.updateHeading
    : TAX_DETAILS_FORM_MESSAGES.addHeading;

  return (
    <div className="tw-flex tw-flex-col tw-gap-10">
      <Text element="h1" typeface="headline-3-m">
        <FormattedMessage {...heading} values={{ taxType: taxTypeName }} />
      </Text>

      <Text element="p" typeface="body-2">
        <FormattedMessage
          {...TAX_DETAILS_FORM_MESSAGES.explainer}
          values={{ taxType: taxTypeName }}
        />
      </Text>

      <Text
        element="a"
        href={isHost ? hostVatSupportLink : guestVatSupportLink}
        rel="noopener noreferrer"
        target="_blank"
        typeface="body-2-underline"
      >
        <FormattedMessage
          {...TAX_DETAILS_FORM_MESSAGES.supportLink}
          values={{ taxType: taxTypeName }}
        />
      </Text>
    </div>
  );
};

export { TaxDetailsFormHeader };
